import { render } from "./OrdersActive.vue?vue&type=template&id=0ab4cc79"
import script from "./OrdersActive.vue?vue&type=script&lang=ts"
export * from "./OrdersActive.vue?vue&type=script&lang=ts"
script.render = render

export default script